(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/differenceBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/differenceBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.differenceBy, global.convert);
    global.differenceBy = mod.exports;
  }
})(this, function (exports, _differenceBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.differenceBy = undefined;

  var _differenceBy3 = _interopRequireDefault(_differenceBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.difference} except that it uses <code>iteratee</code> to generate the value to be compared for each element.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} values The arrays of values to exclude.
   * @param {Function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The iteratee invoked per element.
   * @return {Object} Returns the updated object.
   * @example differenceBy({ nested: { prop: [1.2, 3.4, 5.6] } }, 'nested.prop', [5.4, 2.1], Math.floor) // => { nested: { prop: [1.2, 3.4] } }
   * @see {@link https://lodash.com/docs#differenceBy|lodash.differenceBy} for more information.
   * @since 0.3.0
   */
  var differenceBy = (0, _convert.convert)(_differenceBy3.default);
  exports.differenceBy = differenceBy;
  exports.default = differenceBy;
});